import React from "react";
import {dataProgress} from './servicesData'
import SkillSection from './SkillSection'

const Skill = () => (
    <div className="container-fluid px-md-5" id="skill">
      <div className="page three">
        <h2 className="text-center mb-4 text-uppercase sobremi font-weight-bold colorTexto">
          Habilidades
        </h2>
      </div>
      
      <SkillSection 
      title='Lenguajes de programación en los que he desarrollado' 
      items={dataProgress.filter(({type})=> type==='lenguaje')}
      />

      <SkillSection 
      title='Bases de datos en las que he desarrollado' 
      items={dataProgress.filter(({type})=> type==='database')}
      />

      <SkillSection 
      title='Frameworks que he utilizado en proyectos' 
      items={dataProgress.filter(({type})=> type==='frame')}
      />

      <SkillSection 
      title='Otras herramientas que he utilizado en proyectos' 
      items={dataProgress.filter(({type})=> type==='others')}
      />
    </div>
  );

export default Skill;